import { Component, Input } from "@angular/core";
import { Payment } from "../../models/paymentmodel";
import { transactionService } from "../../services/transaction.service";
import { SharedService } from "../../services/sharedservices.service";
import { accountService } from "../../services/account.service";
import { Session } from "../../models/sessionmodel";
import { Transaction } from "../../models/transactionmodel";
import { Account } from "../../models/accountmodel";
import { PaymentResponse } from "../../models/responsemodel";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from "@angular/forms";
import { Router } from "@angular/router";
import { TransactionChart } from "../../models/chartmodel";
import { Stat } from "../../models/statmodel";
import { Cummulative } from "../../models/cummulativemodel";
import { Observable } from "rxjs";
import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import "rxjs/add/operator/takeWhile";

@Component({
  selector: "doughnut-chart-demo",
  templateUrl: "./dashboard-content.component.html",
  providers: [transactionService]
})
export class DashboardContentComponent {
  @Input() responseObj: Session;
  payment: Payment;
  errorMessage: string;
  public transactionchart: TransactionChart[];
  public transactionStat: Stat[];
  public labels: string[];
  public totalValue: number = 0;
  public successcount: number = 0;
  public failedcount: number = 0;
  public pendingcount: number = 0;
  public totalcount: number = 0;
  public transactions: Transaction[];
  public account: Account;
  public cummulative: Cummulative;

  public daily: string = "0";
  public weekly: string = "0";
  public monthly: string = "0";
  public yearly: string = "0";

  public doughnutChartLabels: string[] = []; // = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  public doughnutChartData: number[] = []; // = [350, 450, 100];
  public doughnutChartType: string = "doughnut";
  public data;
  private display: boolean; // whether to display info in the component
  // use *ngIf="display" in your html to take
  // advantage of this

  private displaystat2: boolean;
  private displaystat: boolean;

  private alive: boolean; // used to unsubscribe from the IntervalObservable
  // when OnDestroy is called.
  public single: any[];
  public singlecummulative: any[];

  colorScheme = {
    domain: ["#C7B42C", "#5AA454", "#5AA454", "#A10A28", "#AAAAAA"]
  };

  colorScheme1 = {
    domain: ["#5AA454", "#5AA454", "#5AA454", "#5AA454"]
  };

  // pie
  showLabels = true;
  explodeSlices = false;
  doughnut = false;
  arcWidth = 0.25;

  constructor(
    private _transactionService: transactionService,
    public router: Router,
    public sharedservice: SharedService,
    public _accountservice: accountService
  ) {
    this.display = false;
    this.alive = true;
  }

  onSelect(event) {
    console.log(event);
  }

  ngOnInit() {
    this.getLast10Transactions();
    this.getStatTransactions();
    this.getCummulativeDaily("daily");
    this.getCummulativeWeekly("weekly");
    this.getCummulativeMonthly("monthly");
    this.getCummulativeYearly("yearly");
    this.getAccount();

    // get our data every subsequent 5 minutes
    // IntervalObservable.create(360000)
    //   .takeWhile(() => this.alive) // only fires when component is alive
    //   .subscribe(() => {
    //     this.getLast10Transactions();
    //     this.getStatTransactions();
    //     this.getCummulative();
    //     this.getAccount();
    //   });
  }

  getAccount() {
    this._accountservice
      .getAccount()
      .subscribe(
        res => this.handleAccountResponse(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getLast10Transactions() {
    this._transactionService
      .getLast10Transactions()
      .subscribe(
        res => this.handleTransResponse(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getStatTransactions() {
    this._transactionService
      .getStatTransactions()
      .subscribe(
        res => this.handleStatResponse(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getCummulativeDaily(period: string) {
    this._transactionService
      .getCummulative(period)
      .subscribe(
        res => this.handleCummulativeResponseDaily(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getCummulativeWeekly(period: string) {
    this._transactionService
      .getCummulative(period)
      .subscribe(
        res => this.handleCummulativeResponseWeekly(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getCummulativeMonthly(period: string) {
    this._transactionService
      .getCummulative(period)
      .subscribe(
        res => this.handleCummulativeResponseMonthly(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getCummulativeYearly(period: string) {
    this._transactionService
      .getCummulative(period)
      .subscribe(
        res => this.handleCummulativeResponseYearly(res),
        error => (this.errorMessage = <any>error)
      );
  }

  getChartTransactions() {
    this._transactionService
      .getChartTransactions()
      .subscribe(
        res => this.handleResponse(res),
        error => (this.errorMessage = <any>error)
      );
  }

  login(isValid: boolean) {
    if (isValid) {
      //this._PaymentService.makePayment(this.payment).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }

  handleStatResponse(result) {
    //console.log(result);
    //console.log(JSON.stringify(result));
    this.transactionStat = result;

    var totalcount = 0;
    var successcount = 0;
    var failedcount = 0;
    var pendingcount = 0;
    var totalValue = 0;

    this.transactionStat.forEach(function (value) {
      if (value.TransactionStatus === "Successful") {
        totalValue = Number(value.TotalValue);
        successcount = Number(value.cnt);
        totalcount += Number(value.cnt);
        //console.log("Success : " + Number(value.cnt))
      } else if (value.TransactionStatus === "Failed") {
        failedcount = Number(value.cnt);
        totalcount += Number(value.cnt);
        //console.log("Failed : " + Number(value.cnt))
      } else if (value.TransactionStatus === "Pending") {
        pendingcount = Number(value.cnt);
        totalcount += Number(value.cnt);
        //console.log("Pending : " + Number(value.cnt))
      }
    });

    this.totalcount = totalcount;
    this.successcount = successcount;
    this.failedcount = failedcount;
    this.pendingcount = pendingcount;
    this.totalValue = totalValue;
    this.displaystat = true;

    this.single = [
      {
        name: "Total Count",
        value: this.totalcount
      },
      {
        name: "Total Successful Value",
        value: this.totalValue
      },
      {
        name: "Successful Count",
        value: this.successcount
      },
      {
        name: "Failed Count",
        value: this.failedcount
      },
      {
        name: "Pending Count",
        value: this.pendingcount
      }
    ];
  }

  handleResponse(result) {
    //console.log(JSON.stringify(result));
    this.transactionchart = result;
    var datadetails: string[] = [];
    var label: number[] = [];

    var cnt = 0;
    var yvalue = [];
    var xvalue = [];

    this.transactionchart.forEach(function (value) {
      datadetails[cnt] = "Amount : " + value.m;
      label[cnt] = Number(value.c);
      xvalue.push("Amount : " + value.m);
      yvalue.push(Number(value.c));
      cnt++;
    });

    this.doughnutChartLabels = xvalue;
    this.doughnutChartData = yvalue;
  }

  handleTransResponse(result) {
    //console.log(JSON.stringify(result));
    this.transactions = result;
    this.data = result;
    this.display = true;
  }

  // handleCummulativeResponse(result) {
  //   //console.log(JSON.stringify(result));
  //   this.cummulative = result;

  //   this.singlecummulative = [
  //     {
  //       name: "Daily Value",
  //       value: result[0].daily
  //     },
  //     {
  //       name: "Weekly Value",
  //       value: result[0].weekly
  //     },
  //     {
  //       name: "Monthly Value",
  //       value: result[0].monthly
  //     },
  //     {
  //       name: "Yearly Value",
  //       value: result[0].yearly
  //     }
  //   ];

  //   this.displaystat2 = true;
  // }

  handleCummulativeResponseDaily(result) {
    //console.log(JSON.stringify(result));
    this.cummulative = result;
    if (result[0].daily == null)
      this.daily = "0";
    else
      this.daily = result[0].daily;

    this.singlecummulative = [
      {
        name: "Daily Value",
        value: this.daily
      },
      {
        name: "Weekly Value",
        value: this.weekly
      },
      {
        name: "Monthly Value",
        value: this.monthly
      },
      {
        name: "Yearly Value",
        value: this.yearly
      }
    ];

    this.displaystat2 = true;
  }
  handleCummulativeResponseWeekly(result) {
    this.cummulative = result;
    if (result[0].weekly == null)
      this.weekly = "0";
    else
      this.weekly = result[0].weekly;

    this.singlecummulative = [
      {
        name: "Daily Value",
        value: this.daily
      },
      {
        name: "Weekly Value",
        value: this.weekly
      },
      {
        name: "Monthly Value",
        value: this.monthly
      },
      {
        name: "Yearly Value",
        value: this.yearly
      }
    ];

    this.displaystat2 = true;
  }
  handleCummulativeResponseMonthly(result) {
    this.cummulative = result;
    if (result[0].monthly == null)
      this.monthly = "0";
    else
      this.monthly = result[0].monthly;

    this.singlecummulative = [
      {
        name: "Daily Value",
        value: this.daily
      },
      {
        name: "Weekly Value",
        value: this.weekly
      },
      {
        name: "Monthly Value",
        value: this.monthly
      },
      {
        name: "Yearly Value",
        value: this.yearly
      }
    ];

    this.displaystat2 = true;
  }
  handleCummulativeResponseYearly(result) {
    this.cummulative = result;

    if (result[0].yearly == null)
      this.yearly = "0";
    else
      this.yearly = result[0].yearly;

    this.singlecummulative = [
      {
        name: "Daily Value",
        value: this.daily
      },
      {
        name: "Weekly Value",
        value: this.weekly
      },
      {
        name: "Monthly Value",
        value: this.monthly
      },
      {
        name: "Yearly Value",
        value: this.yearly
      }
    ];

    this.displaystat2 = true;
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  handleAccountResponse(result) {
    //console.log(JSON.stringify(result[0]));
    this.account = result;
    this.sharedservice.session.account_balance = this.isEmpty(result) ? "0.00" : result[0].balance;
  }
  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  ngOnDestroy() {
    this.alive = false; // switches your IntervalObservable off
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/dashboard/dashboard-content.component.ts